import React, { useState, useEffect, memo } from 'react';
import './ShippingAddress.css';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import * as regex from '../../../constants/RegexConstants';
import { useTranslation } from 'react-i18next';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiFormHelperText-root": {
      fontSize: 9,
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    },
    "& .MuiInputLabel-root": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontWeight: 600,
    },
    "& .MuiInput-input": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "1rem",
    },
    "& .MuiFormLabel-root": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontWeight: 600,
      fontSize: "0.8rem",
    },
    "& .MuiInputLabel-shrink": {
      transform: "scale(1.05)",
      transformOrigin: "top left",
    },

    // [theme.breakpoints.down('xs')]: {
    //   "& .MuiFormHelperText-root": {
    //     fontSize: 8,
    //     fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    //   },
    //   "& .MuiInputLabel-root": {
    //     fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    //     fontWeight: 600,
    //   },
    //   "& .MuiInput-input": {
    //     fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    //     fontSize: "0.55em",
    //     // marginBottom: "5px",
    //   },
    //   "& .MuiFormLabel-root": {
    //     fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    //     fontWeight: 600,
    //     fontSize: "0.55rem",
    //   },
    //   "& .MuiInputLabel-shrink": {
    //     transform: "translate(0, 10px) scale(0.90)",
    //     transformOrigin: "top left",
    //   }
    // },
    helperText: {
      color: "red"
    }
  }
}));

const CustomTextField = (props) => {
  const classes = useStyles();
  const [text, setText] = useState(props.defaultValue);
  const postalCodeRegex = (props.fieldId === 'zip') ? getPostalRegex() : "";
  const phoneRegex = (props.fieldId === 'phone') ? regex.PHONE_US_CA : "";

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (props.fieldId === 'country' || props.fieldId === 'city' || props.fieldId === 'province' || props.fieldId === 'zip') {
      setText(props.defaultValue)
    }
  }, [props.defaultValue])

  return (
    <TextField
      error={checkError() && (props.navAttempts > 0)}
      id={props.fieldId !== undefined ? props.fieldId : ""}
      label={props.label !== undefined ? t(props.label) : ""}
      // label={props.label !== undefined ? t('Welcome to React') : ""}
      placeholder={props.placeholder !== undefined ? props.placeholder : ""}
      // onChange={props.fieldId === 'country' || props.fieldId === 'city' || props.fieldId === 'province' ? undefined : editText}
      onChange={editText}
      value={text}
      helperText={t(getHelperText())}
      variant={props.variant !== undefined ? props.variant : "standard"}
      style={props.containerStyle === undefined ? { width: '45%' } : props.containerStyle}
      disabled={props.disabled ? props.disabled : false}
      onBlur={props.onBlur}
      onKeyDown={props.onKeyPress}
      className={classes.root}
      FormHelperTextProps={{
        classes: { root: classes.helperText }
      }}
    />
  )

  function checkError() {
    if (props.fieldId === 'zip') {
      return (postalCodeRegex.test(text) === false) || (text === '' && props.optional !== true)
    } else if (props.fieldId === 'phone') {
      return (phoneRegex.test(text) === false) || (text === '' && props.optional !== true)
    } else if (typeof props.metaError === 'boolean') {
      return props.metaError
    } else {
      return text === '' && props.optional !== true
    }

  }

  function getHelperText() {
    if (props.fieldId === 'zip') {
      return (text === '' && props.helperText !== undefined && props.optional !== true ? t(props.helperText) : (postalCodeRegex.test(text) === false) ? t(props.helperTextSecondary) : "")
    } else if (props.fieldId === 'phone') {
      return (text === '' && props.helperText !== undefined && props.optional !== true ? t(props.helperText) : (phoneRegex.test(text) === false) ? t(props.helperTextSecondary) : "")
    } else {
      return (text === '' && props.helperText !== undefined && props.optional !== true ? t(props.helperText) : "")
    }
  }

  function editText(e) {
    setText(e.target.value);
    if (props.onEditCallBack !== undefined) {
      props.onEditCallBack(e.target.value)
    }
  }

  function getPostalRegex() {
    return (props.country.toUpperCase() === 'CANADA' ? regex.POSTAL_CA : regex.POSTAL_US);
  }

  function setNewFieldValue(text) {
    setText(text);
  }
}

function areEqual(prevProps, nextProps) {
  if (nextProps.defaultValue !== prevProps.defaultValue) {
    return false;
  } else if (nextProps.navAttempts !== prevProps.navAttempts) {
    return false;
  }
  return true
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
}

export default memo(CustomTextField, areEqual);
